// src/components/auth/GoogleSignInButton.tsx
// Google OAuth sign-in trigger for the welcome / sign-in surfaces.
// Sign-out has moved to ProfilePopover in the sidebar.
import { beginGoogleSignIn } from "@/lib/auth/beginGoogleSignIn";

export function GoogleSignInButton(props: { className?: string }) {
  return (
    <button type="button" onClick={beginGoogleSignIn} className={props.className}>
      Sign in with Google
    </button>
  );
}
